import React from 'react';
import PropTypes from 'prop-types';
import {LargeTitle} from './title';

class RouteContainer extends React.Component {
  render() {
    const {children, scrollingContainerRef, title, className} = this.props;

    return (
      <div className={`${styles.contentContainer} ${className}`} ref={scrollingContainerRef}>
        <div className={styles.innerContent}>
          <LargeTitle className={styles.title}>{title}</LargeTitle>

          <form onSubmit={(event) => event.preventDefault()} className={styles.form}>
            {children}
          </form>
        </div>
      </div>
    );
  }
}

RouteContainer.propTypes = {
  scrollingContainerRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
};

RouteContainer.defaultProps = {
  scrollingContainerRef: () => {},
  style: {},
};

const styles = {
  contentContainer: 'flex justify-center items-center w-full h-full flex-col',
  innerContent:
    'grid grid-cols-[100%] grid-rows-[1fr_min-content_max-content_1fr] h-full w-full sm:max-w-[800px] px-5 sm:px-5',
  title: 'row-start-2',
  form: 'row-start-3 w-full p-1.5',
  label: 'text-[20px] font-thin leading-6 sm:text-[80%] sm:max-w-[800px]',
};

export default RouteContainer;
